export enum ExpressionOperator {
  AND = 'AND',
  OR = 'OR',
}
